module.exports = __webpack_public_path__ + "img/chat.4f45eb9b.png";